import { render, staticRenderFns } from "./invite-user-modal.vue?vue&type=template&id=3081a60e&scoped=true"
import script from "./invite-user-modal.vue?vue&type=script&lang=ts"
export * from "./invite-user-modal.vue?vue&type=script&lang=ts"
import style0 from "./invite-user-modal.vue?vue&type=style&index=0&id=3081a60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081a60e",
  null
  
)

export default component.exports